import React, { useState, useEffect } from "react";
import { Bell, X } from "react-feather";
import { LI, P } from "../../../AbstractElements";
import axios from "axios";
import cookieUtils from "../../../utils/cookieUtils";
import { ServerPath } from "../../../Constant";
import { useNavigate } from 'react-router-dom';

const Notification = ({ active, setActive }) => {
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();

  // Get all possible cookie data
  const userRole = cookieUtils.getSecureCookie('role');
  const userEmail = cookieUtils.getSecureCookie('email');
  const userData = cookieUtils.getSecureCookie('user');
  const adminId = cookieUtils.getSecureCookie('admin_id');
  const userId = cookieUtils.getSecureCookie('user_id');

  // Debug all cookie data
  console.log('Cookie Data:', {
    role: userRole,
    email: userEmail,
    userData,
    adminId,
    userId
  });

  // Try to get userId from various possible sources
  const currentId = userRole === 'superadmin' ? adminId : userId;
  console.log('Using ID:', currentId);

  useEffect(() => {
    if (currentId) {
      fetchNotifications();
      const interval = setInterval(fetchNotifications, 30000);
      return () => clearInterval(interval);
    }
  }, [currentId]);

  const fetchNotifications = async () => {
    try {
      console.log('Fetching notifications for user:', currentId);
      // Changed to match router path
      const response = await axios.get(`${ServerPath}/sos/notifications/user/${currentId}`);
      console.log('Notifications API response:', response.data);

      if (response.data.success === 1) {
        const formattedNotifications = response.data.data.map(notification => ({
          id: notification.notification_id,
          icon: <Bell className={getNotificationColor(notification.type)} />,
          message: notification.message,
          time: formatTimeAgo(notification.created_at),
          priority: getNotificationPriority(notification.type),
          is_read: notification.is_read,
          type: notification.type,
          sos_id: notification.sos_id,
          sender_name: notification.sender_name,
          notification_type: notification.notification_type,
          notification_type_id: notification.notification_type_id,
          notification_sub_type: notification.notification_sub_type
        }));
        console.log('Formatted notifications:', formattedNotifications);
        setNotifications(formattedNotifications);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  const removeNotification = async (id) => {
    try {
      console.log('Marking notification as read:', { id, currentId });
      const response = await axios.put(
        `${ServerPath}/sos/notifications/${id}/read/${currentId}`
      );
      console.log('Mark as read response:', response.data);

      if (response.data.success === 1) {
        // Remove the notification from the list
        setNotifications(prev => prev.filter(notif => notif.id !== id));
      }
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };

  // Helper functions
  const getNotificationColor = (type) => {
    const color = {
      SOS_CREATED: "text-danger",
      SOS_CANCELLED: "text-warning",
      SOS_UPDATED: "text-info"
    }[type] || "text-secondary";
    return color;
  };

  const getNotificationPriority = (type) => {
    const priority = {
      SOS_CREATED: "high",
      SOS_CANCELLED: "medium",
      SOS_UPDATED: "medium"
    }[type] || "low";
    return priority;
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const notificationTime = new Date(timestamp);
    const diffInMinutes = Math.floor((now - notificationTime) / (1000 * 60));

    let formattedTime;
    if (diffInMinutes < 1) formattedTime = "just now";
    else if (diffInMinutes < 60) formattedTime = `${diffInMinutes} min ago`;
    else if (diffInMinutes < 1440) {
      const hours = Math.floor(diffInMinutes / 60);
      formattedTime = `${hours} ${hours === 1 ? 'hr' : 'hrs'} ago`;
    } else {
      const days = Math.floor(diffInMinutes / 1440);
      formattedTime = `${days} ${days === 1 ? 'day' : 'days'} ago`;
    }
    return formattedTime;
  };

  const unreadCount = notifications.filter(n => !n.is_read).length;

  return (
    <LI attrLI={{ className: "onhover-dropdown" }}>
      <div className="notification-box position-relative">
        <Bell onClick={() => setActive("notificationbox")} />
        {unreadCount > 0 && (
          <span className="badge rounded-pill badge-danger position-absolute"
            style={{
              right: "0px",     // Move 5px to the right of the end-0 position
              top: "-5px",
              transform: "translateX(50%)",  // Move it half its width to the right
            }}>
            {unreadCount}
          </span>
        )}
      </div>
      <ul
        className={`notification-dropdown onhover-show-div ${active === "notificationbox" ? "active" : ""}`}
        style={{
          width: "450px",
          right: "-200px",
          padding: "10px",
          maxHeight: "400px",
          overflowY: "auto",
          display: active === "notificationbox" ? "block" : "none",
          zIndex: 999
        }}
      >
        <LI className="d-flex justify-content-between align-items-center p-3 border-bottom">
          <div className="d-flex align-items-center">
            <h6 className="f-18 mb-0">Notifications</h6>
          </div>
          {unreadCount > 0 && (
            <span className="badge rounded-pill badge-danger">{unreadCount} New</span>
          )}
        </LI>

        {notifications.map((notification) => (
          <LI key={notification.id}
            className={`py-3 px-2 border-bottom hover-bg ${!notification.is_read ? 'bg-light' : ''}`}>
            <div className="d-flex align-items-start" onClick={() => {
              console.log('notification', notification)
              notification?.notification_type === 'Listing' && navigate(`${process.env.PUBLIC_URL}/listing`)
            }}>
              <div className="flex-shrink-0 mt-1">
                {notification.icon}
              </div>
              <div className="flex-grow-1 px-3" onClick={() => {
                console.log('notification', notification)
                notification?.notification_type === 'Listing' && navigate(`${process.env.PUBLIC_URL}/listing`)
              }}>
                <P className={`mb-1 ${notification.priority === 'high' ? 'text-danger' :
                  notification.priority === 'medium' ? 'text-warning' : 'text-info'
                  }`} style={{ fontSize: "14px", lineHeight: "1.4" }}>
                  {notification.message}
                </P>
                <span className="f-12 text-muted">{notification.time}</span>
              </div>
              <div className="flex-shrink-0">
                <X
                  className="cursor-pointer text-muted hover-danger"
                  size={16}
                  onClick={(e) => {
                    e.stopPropagation();
                    removeNotification(notification.id);
                  }}
                  style={{ marginTop: "2px" }}
                />
              </div>
            </div>
          </LI>
        ))}

        {notifications.length === 0 && (
          <LI className="p-4">
            <P className="text-center mb-0">No notifications at the moment</P>
          </LI>
        )}
      </ul>

      <style jsx>{`
        .hover-bg:hover {
          background-color: rgba(0, 0, 0, 0.05);
        }
        .hover-danger:hover {
          color: #dc3545;
        }
        .notification-dropdown {
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
          border-radius: 5px;
        }
        .bg-light {
          background-color: rgba(0, 0, 0, 0.02);
        }
        @media (max-width: 576px) {
          .notification-dropdown {
            width: 300px !important;
            right: -100px !important;
          }
        }
      `}</style>
    </LI>
  );
};

export default Notification;